// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountOrderRelationModel {
    static getAttributeTypeMap() {
        return AccountOrderRelationModel.attributeTypeMap;
    }
}
AccountOrderRelationModel.discriminator = undefined;
AccountOrderRelationModel.additionalProperties = false;
AccountOrderRelationModel.attributeTypeMap = [
    {
        "name": "coverageOrder",
        "baseName": "coverageOrder",
        "type": "number"
    },
    {
        "name": "relatedId",
        "baseName": "relatedId",
        "type": "number"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    },
];
//# sourceMappingURL=accountOrderRelationModel.js.map